import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Send, Bell } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", audience: "all" });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const send = async () => {
    if (!form.title || !form.body) { toast.error("Title and message are required."); return; }
    setSaving(true);
    try {
      await api.post("/admin/announcements", form);
      toast.success("Announcement posted to families.");
      setForm({ title: "", body: "", audience: "all" }); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <AppShell admin>
      <h1 className="font-display text-3xl font-bold text-navy">Announcements</h1>
      <p className="text-slateBrand">Communicate with families. In-app now; email/SMS ready to enable later.</p>

      <div className="mt-6 grid gap-8 lg:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <h3 className="font-display font-bold text-navy">New announcement</h3>
          <div className="mt-4 space-y-4">
            <div><Label>Title</Label><Input data-testid="announcement-title" className="mt-1.5 h-11" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
            <div><Label>Message</Label><Textarea data-testid="announcement-body" className="mt-1.5" rows={4} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} /></div>
            <div>
              <Label>Audience</Label>
              <Select value={form.audience} onValueChange={(v) => setForm({ ...form, audience: v })}>
                <SelectTrigger data-testid="announcement-audience" className="mt-1.5 h-11"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Families</SelectItem>
                  <SelectItem value="members">Members Only</SelectItem>
                  <SelectItem value="riders">Transportation Riders</SelectItem>
                  <SelectItem value="chaperones">Chaperones</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Button data-testid="announcement-send" disabled={saving} onClick={send} className="h-12 w-full bg-brandblue font-display font-semibold hover:bg-blue-700"><Send className="mr-2 h-4 w-4" />Post Announcement</Button>
          </div>
        </div>

        <div>
          <h3 className="font-display font-bold text-navy">Recent</h3>
          <div className="mt-4 space-y-3">
            {items.map((a) => (
              <div key={a.id} className="rounded-xl border border-slate-200 bg-white p-4">
                <div className="flex items-center gap-2 font-display font-semibold text-navy"><Bell className="h-4 w-4 text-brandblue" />{a.title}</div>
                <p className="mt-1 text-sm text-slateBrand">{a.body}</p>
                <div className="mt-2 text-xs text-slate-400">{a.audience} • {new Date(a.created_at).toLocaleDateString()}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  );
}
